// Domain-agnostic: empty REACT_APP_BACKEND_URL means relative /api on the
// serving domain (deploy script sets the real URL in frontend/.env on the box).
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
